module.exports = __webpack_public_path__ + "img/bp_giftbg_0009.65111958.png";